export default __webpack_public_path__ + "static/media/ai-legal-advice-cover.3ad2adb1.png";